import { search_asp, trimFieldString, deepcopy } from "../util";
import { getReferenceDefaultValues } from "../../fronto/utility.js";

export function translateMap2BarsNposXQpos(tech, args, line, parsed, source, mapping, processed, config) {
  let rules = [];
  let field_nominal = args[0].replace(/^"/gi, "").replace(/"$/gi, "");
  let field_quantitative = args[1].replace(/^"/gi, "").replace(/"$/gi, "");
  let old_layer = source.layer[mapping[args[2]].layer];
  let old_mark = old_layer.mark.type;
  let old_col = source.layout.column.length == 2 ? source.layout.column[1] : source.layout.column[0];
  if (old_col.constructor.name === "Array") old_col = old_col[0];
  old_col = old_col.field || old_col;
  let old_row = source.layout.row.length == 2 ? source.layout.row[1] : source.layout.row[0];
  if (old_row.constructor.name === "Array") old_row = old_row[0];
  old_row = old_row.field || old_row;
  rules.push({
    category: "recommender",
    description: `Change projection to single`,
    specifier: { role: "view" },
    action: "modify",
    option: { composition: "single" }
  });
  // remove geoshape layers
  let rule_rem_geo = {
    category: "recommender",
    description: `Remove geoshape layers`,
    specifier: { role: "layer", mark: "geoshape" },
    action: "remove"
  };
  rules.push(rule_rem_geo);
  let rule_set_column = {
    category: "recommender",
    description: `Set column field`,
    specifier: { role: "view.column", field: old_col },
    action: "modify",
    option: { field: field_nominal, type: "nominal", sort: "-y" }
  }
  let rule_add_discrete_channel;
  search_asp(parsed, "detect(aggregate_hierarchy,", "startsWith").forEach(p => {
    let highField = trimFieldString(p.args[1]), lowField = trimFieldString(p.args[2]);
    let high_order = {};
    if (lowField === field_nominal) {
      let rel_points = source.data.map((d) => { return { [lowField]: d[lowField], [highField]: d[highField], [field_quantitative]: d[field_quantitative] }; });
      rel_points.forEach((d) => {
        if (!high_order[d[highField]]) high_order[d[highField]] = 0;
        high_order[d[highField]] += d[field_quantitative];
      });
      rule_set_column.option.sort = rel_points.sort((a, b) => {
        return a[highField] !== b[highField] ? (high_order[b[highField]] - high_order[a[highField]]) : (
          a[highField] == a[lowField] ? -1 : (b[highField] == b[lowField] ? 1 : b[field_quantitative] - a[field_quantitative]));
      }).map((d) => d[field_nominal]);
    }
    rule_add_discrete_channel = {
      category: "recommender",
      description: `Add a discrete mark property channel`,
      specifier: { role: "mark", mark: old_mark },
      action: "modify",
      option: {}
    };
    let layer = source.layer[mapping[args[2]].layer];
    if (layer.mark.fill?.value) {
      rule_add_discrete_channel.option.fill = {
        value: null,
        field: highField,
        type: "ordinal",
        scale: {
          domain: Object.keys(high_order).sort((a, b) => high_order[b] - high_order[a]),
          range: [layer.mark.fill?.value, "rgba(190,190,190,1)"]
        }
      }
    } else if (!layer.mark.fill) {
      rule_add_discrete_channel.option.fill = {
        value: null,
        field: highField,
        type: "ordinal"
      }
    }
    if (layer.mark.stroke?.value) {
      rule_add_discrete_channel.option.stroke = {
        value: null,
        field: highField,
        scale: {
          domain: Object.keys(high_order).sort((a, b) => high_order[b] - high_order[a]),
          range: [layer.mark.fill?.value, "rgba(130,130,130,1)"]
        }
      }
    }
  });
  rules.push(rule_set_column);
  if (rule_add_discrete_channel) {
    rules.push(rule_add_discrete_channel);
  }
  rules.push({
    category: "recommender",
    description: `Set row field`,
    specifier: { role: "view.row", field: old_row },
    action: "modify",
    option: { field: field_quantitative, type: "quantitative" }
  });
  let ch_rule = {
    category: "recommender",
    description: `Change mark to bar`,
    specifier: { role: "mark", mark: old_mark },
    action: "modify",
    option: {
      type: "bar"
    }
  };
  search_asp(parsed, "detect(quant_mark_map_with_nominal,", "startsWith").forEach(p => {
    let ch = p.args[1];
    ch_rule.option[ch] = null;
  });
  rules.push(ch_rule);
  let ps;
  if ((ps = search_asp(parsed, "do(highlight_marks_by_values,", "startsWith"), ps?.length > 0)) {
    ps.forEach((p, pi) => {
      if (p.args[1] === args[1]) {
        let layer = source.layer[mapping[p.args[1]].layer];
        let text = layer?.text[mapping[p.args[2]].text];
        let text_values = text?.values;
        if (pi == 0) {
          let rule_dhl = {
            category: "recommender",
            description: `Dehighlight marks`,
            specifier: { role: "mark", mark: "bar" },
            action: "modify",
            option: {}
          };
          if (p.args[4] === "opacity") {
            rule_dhl.option[p.args[4]] = { value: 0.4 };
          }
          if (layer.name !== undefined) {
            rule_dhl.id = layer.name;
          }
          rules.push(rule_dhl);
        }
        text_values?.forEach(value => {
          let rule_hl = {
            category: "recommender",
            description: `Highlight marks`,
            specifier: { role: "mark", mark: "bar", data: {} },
            action: "modify",
            option: {}
          };
          rule_hl.specifier.data[trimFieldString(p.args[3])] = value;
          if (p.args[4] === "opacity") {
            rule_hl.option[p.args[4]] = 1;
          }
          if (layer.name !== undefined) {
            rule_hl.id = layer.name
          }
          rules.push(rule_hl);
        });
      }
    });
  }
  search_asp(parsed, "do(reposition_mark_label_from_map_to_bar,", "startsWith").forEach(p => {
    // do(reposition_mark_label_from_map_to_bar,L,F,non_transpose)
    let layer = source.layer[mapping[p.args[1]]?.layer];
    let is_transposed = p.args[3] === "transpose";
    if (layer) {
      let rule_reposition = {
        category: "recommender",
        description: `Reposition mark label`,
        specifier: { role: "mark.label", mark: "bar", field: trimFieldString(p.args[2]) },
        action: "modify",
        option: {
          orient: (is_transposed ? "middle-right" : "top-center"),
          anchor: (is_transposed ? "start" : "middle"),
          textAlign: (is_transposed ? "left" : "center"),
          dx: (is_transposed ? 5 : 0),
          dy: (is_transposed ? 0 : "-105%"),
        }
      };
      if (layer.name) rule_reposition.specifier.layer = { id: layer.name };
      else if (layer.name) rule_reposition.specifier.layer = { index: parseInt(mapping[p.args[1]]) };
      rules.push(rule_reposition)
    }
  });
  search_asp(parsed, `do(simplify_mark_lables_map_to_bar,${args[2]},`, "startsWith").forEach(p => {
    // do(simplify_mark_lables_map_to_bar,L,T)
    let layer = source.layer[mapping[p.args[1]]?.layer];
    if (layer) {
      let text = layer.text[mapping[p.args[2]]?.text];
      if (text.items) {
        let items = text.items
          .map((d, di) => d.custom == undefined && d.expression == undefined && d.format == undefined ? di : undefined)
          .filter(d => d !== undefined);
        let rule_simplify = {
          category: "recommender",
          description: `Simplify mark label(s)`,
          specifier: { role: "mark.label", mark: "bar", field: text.field },
          action: "remove",
          option: { items: { index: items } }
        };
        if (layer.name) rule_simplify.specifier.layer = { id: layer.name };
        else if (layer.name) rule_simplify.specifier.layer = { index: parseInt(mapping[p.args[1]]) };
        rules.push(rule_simplify);
      }
    }
  });

  // remove existing axis labels
  old_layer.text?.forEach(textItem => {
    if (textItem.type === "on-axis") {
      let rule_remove = {
        category: "recommender",
        description: `Remove axis label for ${textItem.field}`,
        specifier: {
          role: "axis.label",
          field: textItem.field
        },
        action: "remove"
      };
      if (old_layer.name) rule_remove.specifier.layer = { id: old_layer.name };
      else if (mapping[args[2]].layer !== undefined) rule_remove.specifier.layer = { index: mapping[args[2]].layer };
      rules.push(rule_remove);
    }
  })

  search_asp(parsed, 'do(add_axis_label_from_map_to_bars', 'startsWith').forEach(p => {
    let layer = source.layer?.[mapping[p.args[1]]?.layer];
    let field = trimFieldString(p.args[2]);
    if (layer) {
      let text_rule = {
        category: "recommender",
        description: `Add axis label for ${field}`,
        specifier: {
          role: "axis",
          field: field
        },
        action: "add",
        option: {
          role: "label",
          fontSize: 14
        }
      }
      if (layer.name) text_rule.specifier.layer = { id: layer.name };
      else text_rule.specifier.layer = { index: mapping[p.args[1]].layer };
      if (source.datatype?.[field]?.type === "quantitative") {
        text_rule.option.format = ",d";
        if (source.datatype?.[field]?.values)
          text_rule.option.values = getReferenceDefaultValues(source.datatype?.[field]?.values, 4);
      }
      if (search_asp(parsed, "do(transpose).").length == 0 && source.datatype[field].type === "nominal") {
        text_rule.option.angle = -90;
        text_rule.option.textAlign = "right";
      } else if (source.datatype[field].type === "nominal") {
        text_rule.option.textAlign = "right";
      }
      rules.push(text_rule);
    }
  });
  return rules;
}

export function translateMap2Multiples(tech, args, line, parsed, source, mapping, processed, config) {
  // do(map_to_multiples,"shipname",l0).
  let rules = [];
  let field_split = trimFieldString(args[0]);
  let old_col = source.layout.column.length == 2 ? source.layout.column[1] : source.layout.column[0];
  if (old_col.constructor.name === "Array") old_col = old_col[0];
  old_col = old_col.field || old_col;
  let old_row = source.layout.row.length == 2 ? source.layout.row[1] : source.layout.row[0];
  if (old_row.constructor.name === "Array") old_row = old_row[0];
  old_row = old_row.field || old_row;
  let layer = source.layer[mapping[args[1]].layer];
  let quant_field = trimFieldString(args[2]);
  let sort_values;
  if (quant_field && source.datatype[quant_field]) {
    sort_values = deepcopy(source.data).sort((a, b) => b[quant_field] - a[quant_field]).map(d => d[field_split]);
  }
  // remove geoshape layers
  let rule_rem_geo = {
    category: "recommender",
    description: `Remove geoshape layers`,
    specifier: { role: "layer", mark: "geoshape" },
    action: "remove"
  }
  rules.push(rule_rem_geo);
  let rule_comp = {
    category: "recommender",
    description: `Change projection to repeated`,
    specifier: { role: "view" },
    action: "modify",
    option: {
      composition: "repeated",
      split: {
        field: field_split
      },
      nColumns: 3
    }
  };
  if (sort_values) {
    rule_comp.option.split.values = sort_values;
  }
  rules.push(rule_comp);
  rules.push({
    category: "recommender",
    description: `Remove column field`,
    specifier: { role: "view.column", field: old_col },
    action: "remove"
  });
  rules.push({
    category: "recommender",
    description: `Remove row field`,
    specifier: { role: "view.row", field: old_row },
    action: "remove"
  });
  search_asp(parsed, 'do(reposition_legend_from_map_to_multiples', 'startsWith').forEach(p => {
    let layer = source.layer[mapping[p.args[1]].layer];
    let text = layer?.text[mapping[p.args[1]].text];
    if (text) {
      rules.push({
        category: "recommender",
        description: `Reposition legend for ${text.field} to bottom`,
        specifier: { role: "legend", layer: { mark: layer.mark.type, id: layer.name }, field: text.field },
        action: "reposition",
        option: {
          position: "bottom",
          direction: "horizontal"
        }
      })
    }
  });
  let ps;
  if ((ps = search_asp(parsed, "do(highlight_marks_by_values,", "startsWith"), ps?.length > 0)) {
    ps.forEach((p, pi) => {
      if (p.args[1] === args[1]) {
        let layer = source.layer[mapping[p.args[1]].layer];
        let text = layer?.text[mapping[p.args[2]].text];
        let text_values = text?.values;
        if (pi == 0) {
          let rule_dhl = {
            category: "recommender",
            description: `Dehighlight marks`,
            specifier: { role: "mark", mark: layer.mark.type },
            action: "modify",
            option: {}
          };
          if (p.args[4] === "opacity") {
            rule_dhl.option[p.args[4]] = { value: 0.4 };
          }
          if (layer.name !== undefined) {
            rule_dhl.id = layer.name;
          }
          rules.push(rule_dhl);
        }
        text_values?.forEach(value => {
          let rule_hl = {
            category: "recommender",
            description: `Highlight marks`,
            specifier: { role: "mark", mark: layer.mark.type, data: {} },
            action: "modify",
            option: {}
          };
          rule_hl.specifier.data[trimFieldString(p.args[3])] = value;
          if (p.args[4] === "opacity") {
            rule_hl.option[p.args[4]] = 1;
          }
          if (layer.name !== undefined) {
            rule_hl.id = layer.name
          }
          rules.push(rule_hl);
        });
      }
    });
  }
  rules.push({
    category: "recommender",
    description: `Reposition mark labels for ${field_split}`,
    specifier: { role: "mark.label", mark: layer.mark.type, field: field_split },
    action: "modify",
    option: {
      values: null,
      orient: "top-center",
      align: "center",
      anchor: "middle",
      dx: 0,
      dy: "-105%"
    }
  });
  search_asp(parsed, 'do(add_multiples_label', 'startsWith').forEach(p => {
    // add_multiples_label,"shipname").
    let field = trimFieldString(p.args[1]);
    source?.layer?.forEach(layer => {
      let has_mark_label_for_field = layer.text?.filter(text => text.field === field).length > 0;
      if (has_mark_label_for_field) {
        rules.push({
          category: "recommender",
          description: `Reposition mark labels for ${field}`,
          specifier: { role: "mark.label", mark: layer.mark.type, field: field },
          action: "reposition",
          option: {
            orient: "top-center",
            align: "center",
            anchor: "middle",
            dx: 0,
            dy: "-105%"
          }
        })
      } else {
        rules.push({
          category: "recommender",
          description: `Add mark label for ${field}`,
          specifier: { role: "layer", mark: layer.mark.type },
          action: "add",
          option: {
            text: {
              type: "mark",
              field: field,
              orient: "top-center",
              align: "center",
              anchor: "middle",
              dx: 0,
              dy: "-105%"
            }
          }
        })
      }
    });
  });
  search_asp(parsed, 'do(disaggregate_label_text', 'startsWith').forEach(p => {
    // disaggregate_label_text,L,La,Lb).
    let highField = trimFieldString(p.args[2]), lowField = trimFieldString(p.args[3]);
    source?.layer?.forEach(layer => {
      layer.text?.forEach((textItem) => {
        if (textItem.type !== "on-mark") return;
        let new_text_items = textItem.items.map((item, index) => {
          return { expression: item.expression.replace(new RegExp(highField, 'gi'), lowField), index };
        });
        rules.push({
          category: "recommender",
          description: `Disaggregate mark labels for ${lowField}`,
          specifier: { role: "mark.label", id: textItem.name, field: lowField, layer: { id: layer.name } },
          action: "modify",
          option: {
            items: new_text_items
          }
        })
      });
    });
  });

  search_asp(parsed, 'do(copy_multiples_header_from', 'startsWith').forEach(p => {
    // do(copy_multiples_header_from,L,T,F1).
    let textIndex = parseInt(mapping[p.args[2]].text);
    let layerIndex = parseInt(mapping[p.args[2]].layer);
    source?.layer?.forEach((layer, li) => {
      if (li !== layerIndex) return;
      layer.text?.forEach((textItem, ti) => {
        if (ti === textIndex && textItem.type === "on-mark") {
          rules.push({
            category: "recommender",
            description: `Remove unnecessary mark labels`,
            specifier: { role: "mark.label", id: textItem.name, layer: { id: layer.name } },
            action: "remove"
          });
        }
      });
    });
  });
  return rules;
}